export const weatherEn = {
  loading: 'Loading weather…',
  unavailable: 'Weather unavailable',
  weatherUnavailable: 'Weather data is not available for this location.',
  lastUpdated: 'Last updated',
  seasonalHistorical: 'Seasonal estimate (historical average)',
  precip: 'Precipitation',
  humidity: 'Humidity',
  wind: 'Wind',
  attribution: 'Weather data by Open-Meteo',
  noCoords: 'Add city coordinates to see weather.',
  refresh: 'Refresh weather',
  alertsTitle: 'Weather alerts',
  noAlerts: 'No active weather alerts',
  high: 'High',
  low: 'Low',
} as const;
